up.compiler('[delete-additional-item-button]', (element, { additionalItemSelector, message, target }) => {
  if (element.closest('[no-edit]')) return

  const form = element.closest('form')
  const input = element.querySelector('input')

  element.addEventListener('click', function() {
    if (confirm(message)) {
      input.setAttribute('value', true)
      element.closest(additionalItemSelector).setAttribute('hidden', true)

      if (target) {
        up.validate(form, { target: target })
      }
    }
  })
})
